/**
 * 移动端 rem 适配 mixin
 * 设计稿基准：375px 宽，1rem = 100px（即设计稿 px 值 / 100 = rem 值）
 * 进入页面时按屏幕宽度设置 html 根字号，离开页面时还原，不影响 PC 端。
 * 视口宽度限制在 320 ~ 640 之间（平板/桌面预览不无限放大）。
 */
function setRootFontSize () {
  const w = document.documentElement.clientWidth || window.innerWidth || 375
  const base = Math.min(Math.max(w, 320), 640)
  const de = document.documentElement
  de.style.fontSize = (base / 3.75) + 'px'
  // 关闭移动端/模拟器下 Chrome 的字体自动放大（font boosting），保证与原型 1:1
  de.style.setProperty('-webkit-text-size-adjust', '100%')
  de.style.setProperty('text-size-adjust', '100%')
}

function resetRootFontSize () {
  const de = document.documentElement
  de.style.fontSize = ''
  de.style.removeProperty('-webkit-text-size-adjust')
  de.style.removeProperty('text-size-adjust')
}

export default {
  mounted () {
    setRootFontSize()
    window.addEventListener('resize', setRootFontSize)
    window.addEventListener('orientationchange', setRootFontSize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', setRootFontSize)
    window.removeEventListener('orientationchange', setRootFontSize)
    resetRootFontSize()
  }
}



// WEBPACK FOOTER //
// ./src/commonJs/mobileRem.js